import { createApp } from 'vue'
import { createPinia } from 'pinia'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import { initAuth, getAccessToken } from './stores/auth'
import { initThemeEarly } from './config/theme'
import { useThemeStore } from './stores/theme'
import { useLocaleStore } from './stores/locale'
import { i18n } from './i18n'
import './styles/tokens.css'
import './styles/patterns.css'
import './styles/marketing-pages.css'
import './styles/stream-dark.css'
import './style.css'

initThemeEarly()

// Axios interceptor — attach a fresh auth token to every request
axios.interceptors.request.use(
  async (config) => {
    const token = await getAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      config.headers['X-Auth-Token'] = token
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Redirect to login on expired/invalid token
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && error.response?.data?.error?.includes('token')) {
      localStorage.removeItem('authToken')
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)

useThemeStore().init()

const localeStore = useLocaleStore()
localeStore.bindI18n(i18n)
localeStore.init()

app.mount('#app')
initAuth()
